import { useSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import { SuggestedFilterSerializer } from "web/types/serializers";

type UseSuggestedFiltersResult = {
    options?: SuggestedFilterSerializer[];
} | null;

export function useSuggestedFilters(): UseSuggestedFiltersResult {
    const options = useSelector((state: ReduxStoreState) => state.filters.data?.suggested_filters);

    if (!options) {
        return null;
    }

    return {
        options,
    };
}
